/*
 * Lib Module Loaders
 */
Lib.Loader = (function() {

    // Options
    var self = {
        onBeforeUnloadLoader: false
    };

    var cookie_namespace = null;

    // Document ready
    $(Lib).on('document.ready', function() {
        cookie_namespace = Lib.Util.getOption('data.cookie_namespace');
        self.bindLoader();

    });

    /**
     * Bind loaders to some clicks
     */
    self.bindLoader = function() {
        //
        $(document).on('submit', 'form:not([data-no-loader]):not(#debug-kit-toolbar form)', function() {
            self.show();
        });

        //
        $(document).on('submit', 'form[data-no-loader]:not(#debug-kit-toolbar form)', function() {
            self.onBeforeUnloadLoader = false;
        });

        $(document).on('click', 'a[target="_blank"], [download], a[href^="mailto:"], [data-no-unloader]', function() {
            self.onBeforeUnloadLoader = false;
        });

        $(document).on('click', '[data-loader]', function() {
            self.show();
        });

        if (cookie_namespace) {

            $(document).on('click', '[download][data-dlt]', function() {

                // Show the loader
                self.show(false, {text: 'Bestand wordt voorbereid, dit kan even duren...'});

                // Hide the loader
                setTimeout(function() {
                    self.hide();
                }, 2000);
            });
        }

        if ('onbeforeunload' in window) {

            $(window).on('pageshow', function() {
                self.hide();
            });

            $(window).on('beforeunload', function() {
                if (self.onBeforeUnloadLoader) {
                    self.show();
                }
            });

        }
    };

    /**
     *
     * Create the loader
     * @returns jQuery element
     */
    self.create = function(options) {
        var loaderContainer = $('<div />').addClass('loader ' + options.class);
        var spinner = $('<div />').addClass('spinner');
        spinner.appendTo(loaderContainer);

        if (options.text) {
            $('<div />').addClass('loader-text').html(options.text).appendTo(loaderContainer);
        }
        if (options.progress) {
            $('<div />').addClass('loader-progress').html('<span></span>').appendTo(loaderContainer);
        }

        return loaderContainer;
    };

    /**
     * Show the loader
     * Can be called with a parent selector to show the loader in a specific element
     * @param parent_
     * @param options_
     */
    self.show = function(parent_, options_) {

        var modalWrapper = $('#modal-wrapper');
        var loaderParent = self.getLoaderParent(parent_);
        var options = $.extend(true, {
            class: '',
            text: false,
            progress: false
        }, options_);

        if (loaderParent.find('>div.loader').length === 0) {
            var loader = self.create(options);
            loader.appendTo(loaderParent);
            if (loaderParent.is(modalWrapper)) {
                loader.fadeIn(100);
                Lib.Modal.wrapperShow();
            } else {
                loader.fadeIn(100);
            }
        } else {
            if (options.text) {
                self.loaderText(options.text);
            }
        }
    };

    /**
     * Hide the loader
     * @param parent_
     */
    self.hide = function(parent_) {
        var modalWrapper = $('#modal-wrapper');
        var loaderParent = self.getLoaderParent(parent_);
        if (loaderParent instanceof $) {
            loaderParent.find('>.loader').fadeOut(200, function() {
                $(this).remove();
                if (loaderParent.is(modalWrapper)) {
                    Lib.Modal.wrapperHide(true);
                }
            });
        }
    };

    /**
     *
     * @param loaderParent
     * @returns {*}
     */
    self.getLoaderParent = function(loaderParent) {
        var modalWrapper = $('#modal-wrapper');
        switch (loaderParent) {
            case 'modal-card':
                var modalCard = modalWrapper.find('.card:first');
                if (modalCard.length === 1) {
                    return modalCard;
                }
                return modalWrapper;
            default:
                return typeof loaderParent === 'undefined' || loaderParent === false ? modalWrapper : loaderParent;
        }
    };

    /**
     * Delete the loader
     * @param loaderParent
     */
    self.delete = function(loaderParent) {
        loaderParent.find('>.loader').remove();
    };

    self.loaderText = function(text) {
        $('div.loader .loader-text').html(text);
    };

    self.progress = function(perc) {
        var progressBar = $('div.loader .loader-progress span');
        progressBar.width(perc + '%');

        if (perc > 75) {
            progressBar.addClass('top');
            progressBar.removeClass('mid low');
        } else if (perc > 50) {
            progressBar.addClass('mid');
            progressBar.removeClass('top low');
        } else if (perc > 25) {
            progressBar.addClass('low');
            progressBar.removeClass('top mid');
        }
    };

    return self;

})();
